import { useTranslation } from '@/i18n';
import { ActionMenuItems } from '@moneyforward/ap-frontend-components';
import { SearchApprovingInvoiceReportsCsvEncode } from 'ap-openapi';
import { useMemo } from 'react';
import { MenuItem } from './MenuItem';
type ItemArgs = {
  onExport: (type: SearchApprovingInvoiceReportsCsvEncode) => () => void;
};

export const useItems = ({ onExport }: ItemArgs): ActionMenuItems => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        key: '1',
        label: (
          <MenuItem
            label='UTF-8 （BOM付）'
            tooltip={t('approving_invoice_reports.export.utf-8.tooltip')}
          />
        ),
        onClick: onExport(SearchApprovingInvoiceReportsCsvEncode['utf-8']),
      },
      {
        key: '2',
        label: (
          <MenuItem
            label='Shift-JIS'
            tooltip={t('approving_invoice_reports.export.shift-jis.tooltip')}
          />
        ),
        onClick: onExport(SearchApprovingInvoiceReportsCsvEncode['shift_jis']),
      },
    ],
    [onExport, t]
  );
};
